<template>
  <div class="tplogin"></div>
</template>

<script>
import { wxLoginWap } from '@/libs/api.js'
import { getWechatCode } from '@/libs/wechat.js'
import { setStorage, getStorage } from '@/libs/utils'
import { Toast } from 'vant'

export default {
  mounted() {
    console.log(this.$route.query)

    if (!!this.$route.query.code) {
      this.loading = true
      Toast.loading({
        duration: 0,
        mask: true,
        message: '登录中...',
      })
      let query = JSON.parse(localStorage.getItem('tp_data'))

      query = Object.assign({}, query, { code: this.$route.query.code })
      wxLoginWap(query).then((res) => {
        if (res.status == 200) {
          //跳转到 登录前的页面
          Toast.clear()

          let redirect_url = decodeURIComponent(query.redirect_url).split('?')
          if (redirect_url[1]) {
            redirect_url[1] += '&uid=' + res.data.uid
          } else {
            redirect_url[1] = 'uid=' + res.data.uid
          }
          redirect_url = redirect_url.join('?')

          localStorage.removeItem('tp_data');
          window.location.replace(redirect_url)
        }
      })
    } else {
      let query = Object.assign({}, this.$route.query)
      setStorage('tp_data', JSON.stringify(query))
      getWechatCode()
    }
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.tplogin {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
</style>
